export var EnableType;
(function (EnableType) {
    EnableType[EnableType["AlwaysEnable"] = 0] = "AlwaysEnable";
    EnableType[EnableType["ConditionEnable"] = 1] = "ConditionEnable";
})(EnableType || (EnableType = {}));
